<template>
    <div>
        <div>
            <input type="number" disabled :value="props.value.sum" step="0.5" :class="{
                'above-8': props.value.sum > props.threshold, 'below-8': props.value.sum < props.threshold,
                'small-22': props.classa == 0, 'wider-22': props.classa == 1
            }" />
        </div>
        <div>
            <input type="number" disabled :value="props.value.ot" step="0.5" :class="{
                'small-22': props.classa == 0, 'wider-22': props.classa == 1
            }" />
        </div>
    </div>
</template>

<script setup lang="ts">

const props = defineProps(['value', 'threshold', 'classa'])

</script>

<style scoped lang="scss">
.above-8 {
    border-color: blue;
}
.below-8 {
    border-color: red;
}
.small-22 {
    padding-left: 0px;
    width: 27px;
    text-align: center;
    padding-right: 0px;
}
.wider-22 {
    padding-left: 0;
    padding-right: 0;
    text-align: center;
    width: 35px;
}
</style>